import React from 'react'
import { Link } from 'react-router-dom'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './website-creation-main-service.css'

const WebsiteCreationMainService = (props) => {
  return (
    <div className="website-creation-main-service-container1">
      <Helmet>
        <title>Website-Creation-Main-Service - ClearPath Digital</title>
        <meta
          property="og:title"
          content="Website-Creation-Main-Service - ClearPath Digital"
        />
        <link
          rel="canonical"
          href="https://clearpathdigital.teleporthq.app/website-creation-main-service"
        />
      </Helmet>
      <Navigation></Navigation>
      <div className="website-creation-main-service-container2">
        <div className="website-creation-main-service-container3">
          <Script
            html={`<style>
summary.faq-question {
  padding: var(--spacing-lg);
  cursor: pointer;
  font-weight: var(--font-weight-medium);
  list-style: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
summary.faq-question::after {
  content: '+';
  font-size: var(--font-size-xl);
  color: var(--color-primary);
  transition: transform 0.3s ease;
}
@media (prefers-reduced-motion: reduce) {
* {
  animation: none !important;
  transition: none !important;
}
}
</style>`}
          ></Script>
        </div>
      </div>
      <main className="main-container">
        <section className="website-creation--main-service--hero-section">
          <div className="hero-media-wrapper">
            <video
              src="https://videos.pexels.com/video-files/3130284/3130284-hd_1280_720_30fps.mp4"
              loop="true"
              muted="true"
              poster="https://images.pexels.com/videos/3130284/pictures/preview-0.jpg"
              autoPlay="true"
              playsInline="true"
              className="hero-background-video"
            ></video>
            <div className="hero-overlay"></div>
          </div>
          <div className="hero-content-container">
            <div className="hero-text-block">
              <h1 className="website-creation--main-service--hero-title hero-title">
                Your Website Should Be Your Best Sales Asset, Not Just a Cost.
              </h1>
              <p className="hero-subtitle website-creation--main-service--hero-subtitle">
                We build high-converting websites for businesses, startups, and
                local companies in France, Luxembourg, and across the EU. Built
                for speed, trust, and business growth.
              </p>
              <div className="website-creation--main-service--hero-cta-group">
                <Link to="/contact-book-a-call">
                  <div className="website-creation-main-service-thq-btn-elm1 btn btn-primary btn-lg">
                    <span>Book a free website strategy call</span>
                  </div>
                </Link>
              </div>
              <p className="hero-reassurance">
                Fast loading. Mobile optimized. Conversion focused. 100% GDPR
                compliant.
              </p>
            </div>
          </div>
        </section>
        <section className="features-section">
          <div className="features-container">
            <div className="features-header">
              <h2 className="section-title">
                Everything You Need for a Scalable Online Presence
              </h2>
              <p className="section-subtitle">
                A complete, production-ready solution designed for serious
                business owners.
              </p>
            </div>
            <div className="features-grid">
              <div className="feature-card">
                <div className="feature-icon-box">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="m21 21l-4.34-4.34"></path>
                      <circle r="8" cx="11" cy="11"></circle>
                    </g>
                  </svg>
                </div>
                <h3 className="feature-card-title">Strategy &amp; Structure</h3>
                <p className="section-content">
                  We map out the user journey to ensure visitors find exactly
                  what they need to convert.
                </p>
              </div>
              <div className="feature-card">
                <div className="feature-icon-box">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                      <path d="M18.375 2.625a1 1 0 0 1 3 3l-9.013 9.014a2 2 0 0 1-.853.505l-2.873.84a.5.5 0 0 1-.62-.62l.84-2.873a2 2 0 0 1 .506-.852z"></path>
                    </g>
                  </svg>
                </div>
                <h3 className="feature-card-title">Conversion Copywriting</h3>
                <p className="section-content">
                  Full guided copy or professionally written headlines that
                  speak directly to your target clients.
                </p>
              </div>
              <div className="feature-card">
                <div className="feature-icon-box">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M3 12c0-4.243 0-6.364 1.318-7.682S7.758 3 12 3s6.364 0 7.682 1.318S21 7.758 21 12s0 6.364-1.318 7.682S16.242 21 12 21s-6.364 0-7.682-1.318S3 16.242 3 12"></path>
                      <path d="M15 11v4c0 1.1-.657.997-1.6.997a2.35 2.35 0 0 1-1.697-.731A2.55 2.55 0 0 1 11 13.499c0-.663.253-1.299.703-1.767A2.35 2.35 0 0 1 13.4 11zm0 0V8M8 8v8"></path>
                    </g>
                  </svg>
                </div>
                <h3 className="feature-card-title">Premium Design System</h3>
                <p className="section-content">
                  Custom UI that reinforces authority and trust without relying
                  on generic templates.
                </p>
              </div>
              <div className="feature-card">
                <div className="feature-icon-box">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="m16 18l6-6l-6-6M8 6l-6 6l6 6"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                </div>
                <h3 className="feature-card-title">High-Performance Dev</h3>
                <p className="section-content">
                  Clean code and optimized assets for lightning-fast loading
                  speeds on all devices.
                </p>
              </div>
              <div className="feature-card">
                <div className="feature-icon-box">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M6 5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2zm5-1h2m-1 13v.01"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                </div>
                <h3 className="feature-card-title">Mobile Optimization</h3>
                <p className="section-content">
                  Flawless experience on smartphones where 60%+ of your traffic
                  actually happens.
                </p>
              </div>
              <div className="feature-card">
                <div className="feature-icon-box">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M3 3v16a2 2 0 0 0 2 2h16"></path>
                      <path d="m19 9l-5 5l-4-4l-3 3"></path>
                    </g>
                  </svg>
                </div>
                <h3 className="feature-card-title">
                  SEO &amp; Conversion Setup
                </h3>
                <p className="section-content">
                  Basic local SEO foundations and strategic CTA placement to
                  turn visitors into leads.
                </p>
              </div>
            </div>
            <div className="features-audience-split">
              <div className="audience-box for">
                <span className="audience-label">Ideal For</span>
                <p className="section-content">
                  B2B Service Providers, Local Businesses, Startups needing a
                  professional edge, and established companies seeking better
                  conversion.
                </p>
              </div>
              <div className="audience-box not-for">
                <span className="audience-label">Not For</span>
                <p className="section-content">
                  Personal blogs, hobbyists, or those looking for the cheapest
                  $500 template site. We build business assets.
                </p>
              </div>
            </div>
          </div>
        </section>
        <section className="timeline-section">
          <div className="timeline-container">
            <div className="timeline-header">
              <h2 className="section-title">
                Your Path to Launch in 4-6 Weeks
              </h2>
              <p className="section-subtitle">
                A transparent, predictable process with clear milestones.
              </p>
            </div>
            <div className="timeline-track-wrapper">
              <div className="timeline-track">
                <div className="timeline-item">
                  <div className="timeline-marker">
                    <span>Week 1</span>
                  </div>
                  <div className="timeline-content">
                    <h4 className="timeline-item-title">
                      Discovery &amp; Strategy
                    </h4>
                    <p className="section-content">
                      <span>
                        Defining goals, USP, and sitemap.
                        <span
                          dangerouslySetInnerHTML={{
                            __html: ' ',
                          }}
                        />
                      </span>
                      <span className="website-creation-main-service-text13">
                        Client:
                      </span>
                      <span> Brand assets &amp; questionnaire.</span>
                    </p>
                  </div>
                </div>
                <div className="timeline-item">
                  <div className="timeline-marker">
                    <span>Week 2</span>
                  </div>
                  <div className="timeline-content">
                    <h4 className="timeline-item-title">
                      Wireframes &amp; Copy
                    </h4>
                    <p className="section-content">
                      <span>
                        Structuring the flow and drafting core messaging.
                        <span
                          dangerouslySetInnerHTML={{
                            __html: ' ',
                          }}
                        />
                      </span>
                      <span className="website-creation-main-service-text17">
                        Client:
                      </span>
                      <span> Content approval.</span>
                    </p>
                  </div>
                </div>
                <div className="timeline-item">
                  <div className="timeline-marker">
                    <span>Week 3-4</span>
                  </div>
                  <div className="timeline-content">
                    <h4 className="timeline-item-title">Design &amp; UI</h4>
                    <p className="section-content">
                      <span>
                        Crafting the visual identity and custom layouts.
                        <span
                          dangerouslySetInnerHTML={{
                            __html: ' ',
                          }}
                        />
                      </span>
                      <span className="website-creation-main-service-text21">
                        Client:
                      </span>
                      <span> Design feedback.</span>
                    </p>
                  </div>
                </div>
                <div className="timeline-item">
                  <div className="timeline-marker">
                    <span>Week 5</span>
                  </div>
                  <div className="timeline-content">
                    <h4 className="timeline-item-title">Development</h4>
                    <p className="section-content">
                      <span>
                        Building the site with high-performance code.
                        <span
                          dangerouslySetInnerHTML={{
                            __html: ' ',
                          }}
                        />
                      </span>
                      <span className="website-creation-main-service-text25">
                        Client:
                      </span>
                      <span> Final data check.</span>
                    </p>
                  </div>
                </div>
                <div className="timeline-item">
                  <div className="timeline-marker">
                    <span>Week 6</span>
                  </div>
                  <div className="timeline-content">
                    <h4 className="timeline-item-title">
                      Testing &amp; Launch
                    </h4>
                    <p className="section-content">
                      <span>
                        QA, speed optimization, and going live.
                        <span
                          dangerouslySetInnerHTML={{
                            __html: ' ',
                          }}
                        />
                      </span>
                      <span className="website-creation-main-service-text29">
                        Client:
                      </span>
                      <span> Celebration!</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="steps-section">
          <div className="steps-container">
            <div className="steps-grid">
              <div className="website-creation--main-service--step-card">
                <div className="website-creation--main-service--step-number">
                  <span>01</span>
                </div>
                <h3 className="website-creation--main-service--step-title">
                  Strategy Call
                </h3>
                <p className="section-content">
                  We identify your business goals and why your current site
                  isn&apos;t meeting them.
                </p>
              </div>
              <div className="website-creation--main-service--step-card">
                <div className="website-creation--main-service--step-number">
                  <span>02</span>
                </div>
                <h3 className="website-creation--main-service--step-title">
                  Structure &amp; Wireframe
                </h3>
                <p className="section-content">
                  We build the blueprint for conversion before a single pixel is
                  designed.
                </p>
              </div>
              <div className="website-creation--main-service--step-card">
                <div className="website-creation--main-service--step-number">
                  <span>03</span>
                </div>
                <h3 className="website-creation--main-service--step-title">
                  Design &amp; Dev
                </h3>
                <p className="section-content">
                  Premium visuals meet high-performance code to build your sales
                  engine.
                </p>
              </div>
              <div className="website-creation--main-service--step-card">
                <div className="website-creation--main-service--step-number">
                  <span>04</span>
                </div>
                <h3 className="website-creation--main-service--step-title">
                  Launch &amp; Growth
                </h3>
                <p className="section-content">
                  We go live with a site that is built to scale as your business
                  grows.
                </p>
              </div>
            </div>
          </div>
        </section>
        <section className="website-creation--main-service--faq-section">
          <div className="faq-container">
            <div className="faq-header">
              <h2 className="section-title">Common Questions</h2>
              <p className="section-subtitle">
                Everything you need to know before we start.
              </p>
            </div>
            <div className="faq-list">
              <details className="website-creation--main-service--faq-item">
                <summary className="faq-question">
                  <span>How long does the whole process take?</span>
                </summary>
                <div className="faq-answer">
                  <p className="section-content">
                    A typical high-conversion business website takes between 4
                    to 6 weeks from the initial strategy call to the final
                    launch, depending on the complexity and client feedback
                    speed.
                  </p>
                </div>
              </details>
              <details className="website-creation--main-service--faq-item">
                <summary className="faq-question">
                  <span>Do you redesign existing websites?</span>
                </summary>
                <div className="faq-answer">
                  <p className="section-content">
                    Yes, but we treat it as a new build. We don&apos;t just
                    &quot;tweak&quot; old code; we rebuild the strategy and
                    structure from the ground up to ensure maximum conversion
                    performance.
                  </p>
                </div>
              </details>
              <details className="website-creation--main-service--faq-item">
                <summary className="faq-question">
                  <span>Will the site work on mobile devices?</span>
                </summary>
                <div className="faq-answer">
                  <p className="section-content">
                    Absolutely. Every site we build is mobile-first. We ensure
                    it looks and functions perfectly on smartphones, tablets,
                    and desktops.
                  </p>
                </div>
              </details>
              <details className="website-creation--main-service--faq-item">
                <summary className="faq-question">
                  <span>Do you use pre-made templates?</span>
                </summary>
                <div className="faq-answer">
                  <p className="section-content">
                    No. We build custom design systems tailored to your brand
                    and business goals. This ensures your site is unique,
                    professional, and not bloated with unnecessary template
                    code.
                  </p>
                </div>
              </details>
              <details className="website-creation--main-service--faq-item">
                <summary className="faq-question">
                  <span>Can I edit the content myself after launch?</span>
                </summary>
                <div className="faq-answer">
                  <p className="section-content">
                    Yes. We provide a user-friendly CMS setup and a training
                    session so you or your team can update text, images, and
                    blog posts without needing a developer.
                  </p>
                </div>
              </details>
            </div>
          </div>
        </section>
        <section className="website-creation--main-service--final-cta-section">
          <div className="final-cta-container">
            <div className="final-cta-split">
              <div id="book-call" className="booking-block">
                <h2 className="section-title">
                  Ready to build a website that actually works?
                </h2>
                <p className="section-subtitle">
                  Book your free 20-minute strategy call today.
                </p>
                <div className="booking-cta-group">
                  <Link to="/contact-book-a-call">
                    <div className="website-creation-main-service-thq-btn-elm2 btn-outline btn btn-xl">
                      <span>Book a free call</span>
                    </div>
                  </Link>
                </div>
                <p className="gdpr-text">
                  By clicking, you agree to our privacy policy. We respect your
                  data and GDPR compliance.
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <div className="website-creation-main-service-container4">
        <div className="website-creation-main-service-container5">
          <Script
            html={`<style>
        @keyframes fadeInUp {from {opacity: 0;
transform: translateY(30px);}
to {opacity: 1;
transform: translateY(0);}}@keyframes fadeInDown {from {opacity: 0;
transform: translateY(-30px);}
to {opacity: 1;
transform: translateY(0);}}@keyframes fadeIn {from {opacity: 0;}
to {opacity: 1;}}
        </style> `}
          ></Script>
        </div>
      </div>
      <div className="website-creation-main-service-container6">
        <div className="website-creation-main-service-container7">
          <Script
            html={`<script defer data-name="website-creation-ux">
(function(){
  // Simple intersection observer for reveal animations
  const observerOptions = {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);

  // Apply to feature cards and step cards
  document.querySelectorAll('.feature-card, .step-card, .timeline-item').forEach(el => {
    el.style.opacity = '0';
    el.style.transform = 'translateY(20px)';
    el.style.transition = 'all 0.6s ease-out';
    observer.observe(el);
  });

  // Timeline horizontal scroll indicator (optional enhancement)
  const timelineTrack = document.querySelector('.timeline-track-wrapper');
  if (timelineTrack) {
    let isDown = false;
    let startX;
    let scrollLeft;

    timelineTrack.addEventListener('mousedown', (e) => {
      isDown = true;
      startX = e.pageX - timelineTrack.offsetLeft;
      scrollLeft = timelineTrack.scrollLeft;
    });

    timelineTrack.addEventListener('mouseleave', () => {
      isDown = false;
    });

    timelineTrack.addEventListener('mouseup', () => {
      isDown = false;
    });

    timelineTrack.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - timelineTrack.offsetLeft;
      const walk = (x - startX) * 2;
      timelineTrack.scrollLeft = scrollLeft - walk;
    });
  }
})()
</script>`}
          ></Script>
        </div>
      </div>
      <Footer></Footer>
    </div>
  )
}

export default WebsiteCreationMainService
